import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../redux/store'
import {
  fetchSetupTemplates,
  fetchMessageTemplates,
  fetchTriggerSources
} from '../../redux/notificationCenter'
import { RootState } from '../../redux/store'
import NotificationCatalogView from './NotificationCatalogView'

export default function NotificationCatalogContainer() {
  const dispatch: AppDispatch = useDispatch()
  const { setupTemplates, messageTemplates, isLoading, error } = useSelector(
    (state: RootState) => state.notificationCenter
  )
  const [selectedTab, setSelectedTab] = useState(0)

  useEffect(() => {
    dispatch(fetchMessageTemplates({}))
    dispatch(fetchTriggerSources())
  }, [dispatch])

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue)
  }

  return (
    <NotificationCatalogView
      selectedTab={selectedTab}
      onTabChange={handleTabChange}
      setupTemplates={setupTemplates}
      messageTemplates={messageTemplates}
      isLoading={isLoading}
      error={error}
    />
  )
}
